<template>
  <div class="footer">
    <div class="top">
      <div class="footer-links">
        <router-link to="/agreement" class="footer-link">
          {{ $t("用户协议") }}
        </router-link>
        <router-link to="/policy" class="footer-link">
          {{ $t("隐私协议") }}
        </router-link>
        <router-link to="/account-deletion" class="footer-link">
          {{ $t("账户删除声明") }}
        </router-link>
        <router-link to="/cookie" class="footer-link">
          {{ $t("Cookie声明") }}
        </router-link>
        <router-link to="/faq" class="footer-link">
          {{ $t("faq") }}
        </router-link>
      </div>
    </div>
    <div class="bottom">
      <div class="copyright">Copyright ©2026 WFFCard</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "footerPage",
  data() {
    return {
      isShow: false,
      langs: [
        { text: "English", value: "en" },
        { text: "中文", value: "zh" },
        { text: "日本語", value: "jp" },
      ],
      curLanguage: localStorage.getItem("accept_language"),
      currentLan: "",
    };
  },
  methods: {
    handleCommand(command) {
      localStorage.setItem("accept_language", command.value);
      this.$i18n.locale = command.value;
      this.currentLan = this.langs.find(
        (item) => item.value === command.value
      )?.text;
      window.location.reload();
    },
  },
  mounted() {
    this.currentLan = this.langs.find(
      (item) => item.value === this.curLanguage
    )?.text;
  },
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  color: #fff;
  background: #212020;

  .top {
    padding: clamp(30px, 5vw, 40px) clamp(20px, 8vw, 120px);
    width: 100%;
    min-height: 131px;
    border-bottom: 1.49px solid #2b2b2b;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .footer-links {
    display: flex;
    flex-wrap: wrap;
    gap: clamp(30px, 6vw, 100px);
    justify-content: center;
    align-items: center;
  }

  .footer-link {
    font-family: "MiSans-Demibold", sans-serif;
    font-size: clamp(13px, 1.8vw, 14px);
    font-weight: 600;
    line-height: 1.5;
    text-align: center;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    transition: opacity 0.3s, color 0.3s;
    white-space: nowrap;

    &:hover {
      opacity: 0.8;
      color: #f2d074;
    }
  }

  .bottom {
    padding: clamp(20px, 4vw, 30px) clamp(20px, 8vw, 120px);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .copyright {
    font-family: "MiSans-Demibold", sans-serif;
    font-size: clamp(11px, 1.5vw, 12px);
    font-weight: 600;
    line-height: 1.2;
    text-align: center;
    color: #fff;
    opacity: 0.3;
  }
}

// Tablet breakpoint
@media (max-width: 1024px) {
  .footer {
    .footer-links {
      gap: 40px;
    }
  }
}

// Mobile breakpoint
@media (max-width: 768px) {
  .footer {
    .top {
      padding: 30px 20px;
      min-height: auto;
    }

    .footer-links {
      flex-direction: column;
      gap: 20px;
      width: 100%;
    }

    .footer-link {
      font-size: 14px;
      padding: 8px 0;
    }

    .bottom {
      padding: 20px;
    }

    .copyright {
      font-size: 11px;
    }
  }
}

// Small mobile breakpoint
@media (max-width: 480px) {
  .footer {
    .top {
      padding: 25px 15px;
    }

    .footer-links {
      gap: 16px;
    }

    .footer-link {
      font-size: 13px;
    }
  }
}
</style>
